import { LANGUAGE_LABELS, SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/locales'
import { SelectField } from '@/ui'

interface Props {
	value: SupportedLanguage
	onChange: (language: SupportedLanguage) => void
}

export function BookingLanguageSelector({ value, onChange }: Props) {
	return (
		<SelectField
			options={SUPPORTED_LANGUAGES as readonly SupportedLanguage[] as SupportedLanguage[]}
			value={value}
			onChange={onChange}
			renderOption={(language) => LANGUAGE_LABELS[language]}
			hideLabel={true}
			sizing="small"
		/>
	)
}
